import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import {
  Label,
  StyledCheckbox, WrapperField
} from './styled';

const Checkbox = ({
  onChange,
  state,
  theme,
  partialChecked,
  text,
  disabled,
  tooltip
}) => {
  const [check, setCheck] = useState(state);
  useEffect(() => {
    setCheck(state);
  }, [state]);
  const handleChange = (e) => {
    onChange && onChange(e);// eslint-disable-line
    setCheck(!check);
  };
  const getCheckBox = () => {
    return <StyledCheckbox readOnly $partialChecked={ partialChecked } checked={ check } theme={ theme } onClick={ disabled ? null : handleChange } disabled={ disabled } />;
  };

  if (text) {
    return (
      <WrapperField title={ tooltip }>
        {getCheckBox()}
        <Label>{text}</Label>
      </WrapperField>
    );
  }

  return (
    // Since DOM rejects boolean values of not recognized props, added $ on '$partialChecked' to convert it to a transient prop to the styled component
    getCheckBox()
  );
};

Checkbox.propTypes = {
  onChange: PropTypes.func,
  state: PropTypes.bool,
  theme: PropTypes.string,
  partialChecked: PropTypes.bool,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string
};

Checkbox.defaultProps = {
  onChange: null,
  state: false,
  theme: 'green',
  partialChecked: false,
  text: '',
  disabled: false,
  tooltip: ''
};

export default Checkbox;
